export default __webpack_public_path__ + "static/media/icon_fitness.c3193feb.png";